import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-mb-4 tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-200/50 tw-p-4 sm:tw-p-5" }
const _hoisted_2 = { class: "tw-flex tw-flex-wrap tw-items-start tw-justify-between tw-gap-3" }
const _hoisted_3 = { class: "tw-flex tw-flex-wrap tw-items-center tw-gap-2" }
const _hoisted_4 = { class: "tw-mt-4 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3" }
const _hoisted_5 = { class: "tw-flex tw-flex-wrap tw-items-center tw-gap-2" }
const _hoisted_6 = { class: "tw-flex tw-flex-wrap tw-items-center tw-gap-2" }
const _hoisted_7 = { class: "tw-flex tw-flex-wrap tw-items-center tw-gap-4" }
const _hoisted_8 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700 tw-cursor-pointer" }
const _hoisted_9 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700 tw-cursor-pointer" }
const _hoisted_10 = { class: "tw-flex tw-flex-wrap tw-items-center tw-gap-3" }
const _hoisted_11 = {
  key: 0,
  class: "tw-text-sm tw-text-slate-600"
}
const _hoisted_12 = { class: "tw-font-semibold tw-text-slate-900" }
const _hoisted_13 = { class: "tw-w-full sm:tw-w-[320px]" }
const _hoisted_14 = { class: "tw-overflow-auto" }
const _hoisted_15 = { class: "tw-w-full tw-border-collapse tw-text-left tw-text-sm tw-text-slate-800" }
const _hoisted_16 = { class: "tw-border-b tw-border-slate-200/70 tw-bg-white/50" }
const _hoisted_17 = {
  key: 0,
  class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700 tw-text-right"
}
const _hoisted_18 = {
  key: 0,
  class: "tw-border-b tw-border-slate-200/50"
}
const _hoisted_19 = ["colspan"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "tw-ml-2 tw-text-[10px] tw-uppercase tw-bg-slate-100 tw-px-1.5 tw-py-0.5 tw-rounded tw-text-slate-500"
}
const _hoisted_22 = { class: "tw-px-4 tw-py-3 tw-text-slate-700" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 2,
  class: "tw-text-slate-400"
}
const _hoisted_26 = { class: "tw-px-4 tw-py-3 tw-text-slate-700" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  key: 2,
  class: "tw-text-slate-400"
}
const _hoisted_30 = { class: "tw-px-4 tw-py-3 tw-text-slate-700" }
const _hoisted_31 = { class: "tw-px-4 tw-py-3 tw-text-slate-700" }
const _hoisted_32 = {
  key: 0,
  class: "tw-px-4 tw-py-3 tw-text-right"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "tw-mt-4 tw-flex tw-justify-center" }
const _hoisted_36 = { class: "tw-p-1" }
const _hoisted_37 = { class: "tw-text-sm tw-text-slate-600" }
const _hoisted_38 = { class: "tw-font-bold tw-text-slate-900" }
const _hoisted_39 = { class: "tw-mt-6 tw-flex tw-justify-end tw-gap-3" }
const _hoisted_40 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreateCustomerModal = _resolveComponent("CreateCustomerModal")!
  const _component_CustomerDetails = _resolveComponent("CustomerDetails")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ListPage = _resolveComponent("ListPage")!
  const _component_PaginationBar = _resolveComponent("PaginationBar")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ListPage, { variant: "page" }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_CreateCustomerModal, {
            isOpen: _ctx.isCreateCustomerOpen,
            "onUpdate:isOpen": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCreateCustomerOpen) = $event)),
            onCreatedCustomer: _ctx.createdCustomer,
            showingCustomerType: _ctx.showingCustomerType
          }, null, 8, ["isOpen", "onCreatedCustomer", "showingCustomerType"]),
          _createVNode(_component_CustomerDetails, {
            isOpen: _ctx.isCustomerDetailsOpen,
            "onUpdate:isOpen": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isCustomerDetailsOpen) = $event)),
            onClose: _ctx.closeCustomerDetails,
            customerId: _ctx.currentCustomerId
          }, null, 8, ["isOpen", "onClose", "customerId"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "tw-min-w-0" }, [
                _createElementVNode("div", { class: "tw-flex tw-flex-wrap tw-items-baseline tw-gap-x-3 tw-gap-y-1" }, [
                  _createElementVNode("h1", { class: "tw-text-2xl sm:tw-text-3xl tw-font-semibold tw-tracking-tight tw-text-slate-800" }, "Customers"),
                  _createElementVNode("div", { class: "tw-text-sm tw-text-slate-600" }, "Manage customers and receivers.")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_3, [
                (!_ctx.isSearching)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "tw-inline-flex tw-items-center tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm tw-shadow-slate-900/10 hover:tw-bg-slate-800",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isCreateCustomerOpen = true))
                    }, " Add new " + _toDisplayString(_ctx.showingCustomerType == 'billing' ? 'customer' : 'receiver'), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.showingCustomerType === 'billing' ? 'tw-border-transparent tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white']),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setCustomerType('billing')))
                  }, " Customers ", 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.showingCustomerType === 'receiving' ? 'tw-border-transparent tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white']),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setCustomerType('receiving')))
                  }, " Receivers ", 2),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", _hoisted_8, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showActiveOnly) = $event)),
                        onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleActiveFilter && _ctx.toggleActiveFilter(...args))),
                        class: "tw-h-4 tw-w-4 tw-rounded tw-border-slate-300 tw-text-slate-900"
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.showActiveOnly]
                      ]),
                      _cache[17] || (_cache[17] = _createTextVNode(" Active only ", -1))
                    ]),
                    _createElementVNode("label", _hoisted_9, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showDeactivatedOnly) = $event)),
                        onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleDeactivatedFilter && _ctx.toggleDeactivatedFilter(...args))),
                        class: "tw-h-4 tw-w-4 tw-rounded tw-border-slate-300 tw-text-slate-900"
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.showDeactivatedOnly]
                      ]),
                      _cache[18] || (_cache[18] = _createTextVNode(" Deactivated only ", -1))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                (!_ctx.isSearching)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createTextVNode(" Total # " + _toDisplayString(_ctx.showingCustomerType) + ": ", 1),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.customersCount), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_SearchInput, {
                    modelValue: _ctx.searchTerm,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchTerm) = $event)),
                    placeholder: `Search ${_ctx.showingCustomerType == 'billing' ? 'customer' : 'receiver'} name`,
                    class: "tw-w-full"
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ])
            ])
          ]),
          _createVNode(_component_ListPage, {
            variant: "card",
            loading: _ctx.$apollo.queries.customers && _ctx.$apollo.queries.customers.loading,
            cardPadding: false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("table", _hoisted_15, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_16, [
                      _cache[19] || (_cache[19] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700" }, "Customer Name", -1)),
                      _cache[20] || (_cache[20] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700" }, "City", -1)),
                      _cache[21] || (_cache[21] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700" }, "State", -1)),
                      _cache[22] || (_cache[22] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700" }, "# Containers", -1)),
                      _cache[23] || (_cache[23] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700" }, "Type", -1)),
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_17, "Actions"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_ctx.sortedCustomers.length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                          _createElementVNode("td", {
                            class: "tw-px-4 tw-py-6 tw-text-sm tw-text-slate-600",
                            colspan: _ctx.isAdmin ? 6 : 5
                          }, " No customers found. ", 8, _hoisted_19)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedCustomers, (customer) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: customer.id || customer.name,
                        class: _normalizeClass(["tw-border-b tw-border-slate-200/50 hover:tw-bg-slate-50/70 tw-cursor-pointer", [!customer.isActive ? 'tw-opacity-60' : '']]),
                        onClick: ($event: any) => (_ctx.selectCustomer(customer.id))
                      }, [
                        _createElementVNode("td", {
                          class: _normalizeClass(["tw-px-4 tw-py-3 tw-font-medium", customer.isActive ? 'tw-text-slate-900' : 'tw-text-slate-500'])
                        }, [
                          _createTextVNode(_toDisplayString(customer.displayName ? customer.displayName : customer.name) + " ", 1),
                          (!customer.isActive)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Inactive"))
                            : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("td", _hoisted_22, [
                          (customer.deliveryAddress)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(customer.deliveryAddress.city), 1))
                            : (customer.billingAddress)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(customer.billingAddress.city), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_25, "—"))
                        ]),
                        _createElementVNode("td", _hoisted_26, [
                          (customer.deliveryAddress)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(customer.deliveryAddress.state), 1))
                            : (customer.billingAddress)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(customer.billingAddress.state), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_29, "—"))
                        ]),
                        _createElementVNode("td", _hoisted_30, _toDisplayString(customer.activeContainersCount || 0), 1),
                        _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.customerType(customer)), 1),
                        (_ctx.isAdmin)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_32, [
                              (customer.isActive)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "tw-text-slate-400 hover:tw-text-red-600 tw-transition-colors tw-p-2",
                                    title: "Deactivate",
                                    onClick: _withModifiers(($event: any) => (_ctx.openStatusModal(customer)), ["stop"])
                                  }, [
                                    _createVNode(_component_font_awesome_icon, { icon: "trash" })
                                  ], 8, _hoisted_33))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "tw-text-slate-400 hover:tw-text-emerald-600 tw-transition-colors tw-p-2",
                                    title: "Activate",
                                    onClick: _withModifiers(($event: any) => (_ctx.openStatusModal(customer)), ["stop"])
                                  }, [
                                    _createVNode(_component_font_awesome_icon, { icon: "rotate-right" })
                                  ], 8, _hoisted_34))
                            ]))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_20))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["loading"]),
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_PaginationBar, {
              page: _ctx.page,
              totalPages: _ctx.totalPages,
              onPreviousPage: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updatePage(-1))),
              onNextPage: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updatePage(1))),
              onGoToPage: _ctx.goToPage
            }, null, 8, ["page", "totalPages", "onGoToPage"])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Modal, {
      isOpen: _ctx.isStatusModalOpen,
      "onUpdate:isOpen": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isStatusModalOpen) = $event)),
      modalId: "customer-status-modal",
      maxWidth: "sm",
      onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isStatusModalOpen = false))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.customerToUpdate?.isActive ? 'Deactivate Customer' : 'Activate Customer'), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("p", _hoisted_37, [
            _createTextVNode(" Are you sure you want to " + _toDisplayString(_ctx.customerToUpdate?.isActive ? 'deactivate' : 'activate') + " ", 1),
            _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.customerToUpdate?.name), 1),
            _cache[24] || (_cache[24] = _createTextVNode("? ", -1))
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("button", {
              type: "button",
              class: "tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isStatusModalOpen = false))
            }, " Cancel "),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-xl tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm", _ctx.customerToUpdate?.isActive ? 'tw-bg-red-600 hover:tw-bg-red-700' : 'tw-bg-emerald-600 hover:tw-bg-emerald-700']),
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.confirmToggleActive && _ctx.confirmToggleActive(...args))),
              disabled: _ctx.isProcessing
            }, [
              (_ctx.isProcessing)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: "circle-notch",
                    spin: "",
                    class: "tw-mr-2"
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.customerToUpdate?.isActive ? 'Deactivate' : 'Activate'), 1)
            ], 10, _hoisted_40)
          ])
        ])
      ]),
      _: 1
    }, 8, ["isOpen"])
  ], 64))
}